import { render, staticRenderFns } from "./SimulatorCalculator.vue?vue&type=template&id=476bc075&"
import script from "./SimulatorCalculator.vue?vue&type=script&lang=ts&"
export * from "./SimulatorCalculator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports